import { render } from "./ReLoginPage.vue?vue&type=template&id=e0d96a42&scoped=true&ts=true"
import script from "./ReLoginPage.vue?vue&type=script&lang=ts"
export * from "./ReLoginPage.vue?vue&type=script&lang=ts"

import "./ReLoginPage.vue?vue&type=style&index=0&id=e0d96a42&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0d96a42"]])

export default __exports__